export function cn(...inputs: (string | boolean | undefined)[]) {
  return inputs.filter((el) => el).join(" ");
}
